import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/contracts/$subscriptionId/')({
  component: () => (
    <Navigate replace search from="/bak/contracts/$subscriptionId/" to="/bo/contracts/$subscriptionId" />
  ),
})
